import {
  connect as adFoxConnect,
  TAdFoxBannerProps as TAdFoxBannerComponentProps,
  IAdFoxBannerOnLoadData,
  IAdFoxBannerOnErrorError,
} from '@cian/adfox-component';
import { IWithPostViewAnalyticsPayload, withAdfoxPostViewAnalytics } from '@cian/postview-analytics-utils';
import * as React from 'react';

import { OwnTemplates } from './OwnTemplates';
import { useAdsDisabled } from '../../../../../browser/utils/hooks';
import { AdfoxContext } from '../../../../utils/adfox/context';

const AdFoxBannerComponent = adFoxConnect(OwnTemplates);

type TAdFoxBannerProps = TAdFoxBannerComponentProps & {
  disableYan?: boolean;
  position?: number;
  postViewAnalyticsData?: IWithPostViewAnalyticsPayload;
};

export function AdFoxBanner(props: TAdFoxBannerProps) {
  const [isHidden, setHidden] = React.useState(false);
  const context = React.useMemo(() => ({ position: props.position }), [props.position]);

  const handleLoad = React.useCallback(
    (data: IAdFoxBannerOnLoadData) => {
      const { bundleName } = data;

      if (props.disableYan && bundleName === 'banner.direct') {
        setHidden(true);
      }
    },
    [props.disableYan],
  );

  const handleStub = React.useCallback(() => {
    setHidden(true);
    if (props.onStub) {
      props.onStub();
    }
  }, []);

  const handleError = React.useCallback((error: IAdFoxBannerOnErrorError) => {
    if (props.onError) {
      props.onError(error);
    }
  }, []);

  useAdsDisabled(() => {
    handleStub();
  }, []);

  const banner = React.useMemo(() => {
    const bannerProps = {
      ...props,
      onLoad: handleLoad,
      onStub: handleStub,
      onError: handleError,
    };

    if (props.postViewAnalyticsData) {
      const AdfoxWithPostView = withAdfoxPostViewAnalytics(
        AdFoxBannerComponent,
        bannerProps,
        props.postViewAnalyticsData,
      );

      return <AdfoxWithPostView />;
    }

    return <AdFoxBannerComponent {...bannerProps} />;
  }, [props, handleLoad, handleStub, handleError]);

  if (isHidden) {
    return null;
  }

  return <AdfoxContext.Provider value={context}>{banner}</AdfoxContext.Provider>;
}
